import { PublicationStorageFile as Data } from '@/typings/api/Publication'

import { EDIT, VIEW, DELETE } from '@/helpers/enums/table-actions'


export const TABLE_ACTIONS = Object.freeze([
  EDIT,
  VIEW,
  DELETE,
])

export const TABLE_HEADERS = Object.freeze([
  {
    text: 'Название',
    value: 'filename',
    sortable: false,
  },
  {
    text: 'Пользователи',
    value: 'users',
    sortable: false,
    field: (_: void, value: Data) => value.users.map(({ username }) => username).join(', '),
  },
])
